import { gql } from '@apollo/client/core';

const simpleSpecPackEngineAttributes = {
  SIMPLE_SPEC_PACK_ENGINE: gql`
    fragment SimpleSpecPackEngine on Engine {
      attributes {
        transmissionType
        transmissionLabel
        fuelType
        fuelLabel
        longdescription
        powertrain
        capacity
        maximumpower
        enginepower
        maximumtorque
      }
    }
  `,
};

export default simpleSpecPackEngineAttributes;
